import React from "react";
import { withRouter } from "react-router-dom";
import moment from "moment";

import SaludPymesContactForm, { ContactData } from "../forms/contact-item/contact-form-item";
import SaludPymesAddressForm, { AddressData } from "../forms/address-item/address-form-item";
import InsuredPersonalInformation from "../forms/insured-personal-information/insured-personal-information";
import LegalRepreData from "../forms/repre-data/repre-data";
import LeftInfoModal from "../../../../../components/left-info-modal";
import MainButton from "../../../../../components/main-button";
import { Label } from "../../../../../components/form";
import { images } from "../../../../../assets";
import { InsuredDataContainer } from "./salud-pymes-insured-style";

import { SIGN_HIRING_STATUS_TYPE } from "../../../../../constants/hiring";
import { withCoverages } from "../../../../../context/mixin/with-coverages";
import { withGeneral } from "../../../../../context/mixin/with-general";
import { withPolicy } from "../../../../../context/mixin/with-policy";

import ConstantsServices from "../../../../../services/ConstantsServices";
import { emptyLegalGuardianData } from "../forms/repre-data/repre-data-helpers";
import { SaludPymesHireMenuHelper } from "../../../../../components/salud-pymes-hire-menu";
import { deepGet } from "../../../../../utils/utility";
import { Taker } from "../salud-pymes-guarantee/health-guarantee-dto/health-guarantee-risks-dto";
import { InsuredPersonalData } from "../forms/insured-personal-information/insured-personal-information-types";
import { InsuredLegalRepre } from "../forms/repre-data/repre-data-types";
import { InsuredProps, InsuredState, StateInsuredData } from "./salud-pymes-insured-types";

class SaludPymesInsured extends React.Component<InsuredProps, InsuredState> {
  constructor(props: any) {
    super(props);

    const indexInsured = this.props.match.params.index ? Number(this.props.match.params.index) : -1;

    this.state = {
      validateContact: {
        validateRequest: false,
        isValidated: false,
      },
      validateAddress: {
        validateRequest: false,
        isValidated: false,
      },
      validatePerson: {
        validateRequest: false,
        isValidated: false,
      },
      validateRepre: {
        validateRequest: false,
        isValidated: false,
      },
      cleanForm: false,
      personalData: {
        name: "",
        birthDate: new Date().toLocaleDateString(),
        docNumber: "",
        gender: "",
        docType: "",
        lastname1: "",
        nationality: "",
        nationalityLabel: "",
        profession: { value: "", code: "", other: "" },
        lastname2: "",
        sameAsTaker: false,
        passportDate: undefined,
      },
      contactData: {
        email: "",
        mobilePhone: "",
        landlinePhone: "",
        sameAsTaker: false,
      },
      addressData: {
        address: { value: "", code: "", label: "" },
        wayType: "",
        number: "",
        postalCode: "",
        province: { value: "", code: "", label: "" },
        town: { value: "", code: "", label: "" },
        door: "",
        floor: "",
        portal: "",
        stairs: "",
        sameAsTaker: false,
        normalizaDireciones: "S",
      },
      previousModalShow: false,
      nextModalShow: false,
      usePersonalData: false,
      useAddressData: false,
      useContactData: false,
      indexInsured: indexInsured,
      anyChange: false,
      isPersonalCheckChanging: false,
      cancelSignModalShow: false,
      showMinInsuredsModal: false,
      sameAsTakerChecked: false,
      hasLegalRepre: deepGet(props.data.insureds, `${indexInsured}.hasLegalRepre`, false) || false,
      legalGuardian:
        deepGet(props.data.insureds, `${indexInsured}.legalGuardian`) || emptyLegalGuardianData,
      relationshipList: [],
      showRepreModal: false,
    };
  }

  componentWillReceiveProps(nextProps: any) {
    if (nextProps.saveInsured) {
      this.saveInsured();
    }

    if (nextProps.removeInsured) {
      this.removeInsured();
    }

    if (nextProps.newInsured || this.props.location.search.indexOf("new=true") > 0) {
      this.setState(
        {
          cleanForm: true,
          indexInsured: -1,
          usePersonalData: false,
          useAddressData: false,
          useContactData: false,
          sameAsTakerChecked: false,
          hasLegalRepre: false,
          legalGuardian: emptyLegalGuardianData,
        },
        () => this.setState({ cleanForm: false }),
      );
      this.props.history.replace("/contratacion/nueva/salud-pymes/asegurados/");
    } else if (
      nextProps.onGotoDetail !== undefined &&
      nextProps.onGotoDetail !== this.state.indexInsured
    ) {
      const insuredList = this.props.data.insureds;
      const insuredData = insuredList[nextProps.onGotoDetail];

      this.setState({
        indexInsured: nextProps.onGotoDetail,
        usePersonalData:
          nextProps.onGotoDetail === 0 ? insuredData && insuredData.sameAsTaker : false,
        useAddressData: insuredData && insuredData.address && insuredData.address.sameAsTaker,
        useContactData: insuredData && insuredData.sameAsTaker,
        sameAsTakerChecked: insuredData && insuredData.sameAsTaker,
        hasLegalRepre: (insuredData && insuredData.hasLegalRepre) || false,
        legalGuardian: (insuredData && insuredData.legalGuardian) || emptyLegalGuardianData,
      });
    } else {
      const { anyChange } = this.state;
      if (anyChange == true) {
        this.setState({ anyChange: false });
      }
    }
  }

  componentDidUpdate() {
    const { history } = this.props;
    const {
      validateContact,
      validateAddress,
      validatePerson,
      validateRepre,
      cleanForm,
      hasLegalRepre,
    } = this.state;

    if (validateAddress.validateRequest) {
      validateAddress.validateRequest = false;
      validateContact.validateRequest = false;
      validatePerson.validateRequest = false;
      validateRepre.validateRequest = false;

      if (
        validateContact.isValidated &&
        validateAddress.isValidated &&
        validateAddress.isValidated &&
        (!hasLegalRepre || (hasLegalRepre && validateRepre.isValidated))
      ) {
        history.push("/contratacion/nueva/salud-pymes/garantias");
      }

      if (cleanForm) {
        this.setState({ cleanForm: false });
      }
    }
  }
  _actualizarCuestionarios = (index: number, insured: any, insureds: any[], value: any = "") => {
    // En el insured nos llegaria el dni actualizado
    // Tenemos que buscar
    try {
      let val1 = insureds[index][value];
      let val2 = insured[value];
      if (value === "birthDate") return !moment(val1).isSame(moment(val2));
      return val1 !== val2;
    } catch (x) {
      return false;
    }
  };

  _existsQuestionnaire = (docNumber: string) => !!this.props.data.questionnaires[docNumber];

  componentDidMount = () => {
    const { match, history, data } = this.props;

    if (
      history &&
      history.location &&
      history.location.search &&
      history.location.search.indexOf("new=true") > 0
    ) {
      this.setState({ indexInsured: -1, cleanForm: true });
      return;
    }
    if (match && match.params && match.params.index) {
      const insuredList = this.props.data.insureds;
      const useAddressData =
        insuredList.length > 0 && insuredList[match.params.index].address.sameAsTaker;

      const useContactData = insuredList.length > 0 && insuredList[match.params.index].sameAsTaker;

      const usePersonalData = insuredList.length > 0 && insuredList[match.params.index].sameAsTaker;

      this.setState({
        indexInsured: match.params.index,
        useAddressData,
        usePersonalData,
        useContactData,
      });
    }
    setTimeout(function () {
      window.scrollTo(0, 0);
    }, 100);

    if (data.insureds !== undefined && data.insureds.length !== 0) {
      this.setSimulationDataInvalid();
    }

    this.handleInsuredAsTakerChange();
    this.props.haveInsuredSaved(false);
    this.getRelationshipList();
  };

  getRelationshipList = async () => {
    const response = await ConstantsServices.getRelationShips({
      setLoading: () => {},
      loader: false,
    });
    if (response.ok) {
      const relationshipList = response.data.map((relation) => ({
        label: relation.description,
        value: relation.code,
      }));
      this.setState({ relationshipList });
    }
  };

  setSimulationDataInvalid() {
    this.setState({ indexInsured: 0 });
  }

  toValidate = async () => {
    let {
      validateContact,
      validateAddress,
      validatePerson,
      validateRepre,
      hasLegalRepre,
    } = this.state;
    validateContact.validateRequest = true;
    validateAddress.validateRequest = true;
    validatePerson.validateRequest = true;
    if (hasLegalRepre) {
      validateRepre.validateRequest = true;
    }

    this.setState({ validateContact, validateAddress, validatePerson, validateRepre });
  };

  async saveInsured() {
    if (
      this.props.data &&
      this.props.data.signData &&
      this.props.data.signData.signStatus === SIGN_HIRING_STATUS_TYPE.REQUESTED
    )
      this.setState({ cancelSignModalShow: true });
    else {
      await this.validateAndSave();
    }
  }

  async validateAndSave() {
    if (
      this.props.data &&
      this.props.data.signData &&
      this.props.data.signData.signStatus === SIGN_HIRING_STATUS_TYPE.REQUESTED
    ) {
      this.props.removeSign();
    }

    await this.toValidate();

    const { hasLegalRepre, validateAddress, validateContact, validatePerson, validateRepre } =
      this.state;
    if (
      validateAddress.isValidated &&
      validateContact.isValidated &&
      validatePerson.isValidated &&
      (!hasLegalRepre || (hasLegalRepre && validateRepre.isValidated))
    ) {
      const { personalData, contactData, addressData, legalGuardian, hasLegalRepre } = this.state;
      let { indexInsured } = this.state;

      let insured = {
        ...personalData,
        ...contactData,
        hasLegalRepre,
        ...(hasLegalRepre ? { legalGuardian } : {}),
        address: addressData,
        insured: true,
        coverages: [],
        beneficiaries: [],
        isDataValid: true,
      };
      // TENEMOS  en this.state.indexInsured el seleccionado y en this.props.data.insureds todos.
      // Tenemos que mirar si el insured ha cambiado algo y cambiarlo en questi
      if (
        this.props.data &&
        this.state.indexInsured !== undefined &&
        this.state.indexInsured !== -1 &&
        this.props.data.questionnaires &&
        this.props.data.insureds &&
        this._existsQuestionnaire(this.props.data.insureds[indexInsured].docNumber)
      ) {
        //Comprobar dni
        if (
          this._actualizarCuestionarios(
            this.state.indexInsured,
            insured,
            this.props.data.insureds,
            "docNumber",
          )
        ) {
          // Tenemos que actualizar cuestionarios
          this.props.data.questionnaires[insured.docNumber] =
            this.props.data.questionnaires[this.props.data.insureds[indexInsured].docNumber];
          delete this.props.data.questionnaires[this.props.data.insureds[indexInsured].docNumber];
          // aqui tenemos guardada la key del questionary pero nos falta actualizar el docNumber
          this.props.data.questionnaires[insured.docNumber].insuredDocNumber = insured.docNumber;
        }
        //Comprobar fecha de nacimiento
        if (
          this._actualizarCuestionarios(
            this.state.indexInsured,
            insured,
            this.props.data.insureds,
            "birthDate",
          )
        ) {
          this.props.data.questionnaires[insured.docNumber].questionnaireData.questionnaireResponse[
            "04"
          ].value = moment(insured.birthDate).format("DD/MM/YYYY");
        }
        if (
          this._actualizarCuestionarios(
            this.state.indexInsured,
            insured,
            this.props.data.insureds,
            "gender",
          )
        ) {
          this.props.data.questionnaires[insured.docNumber].questionnaireData.questionnaireResponse[
            "02"
          ].value = insured.gender;
        }
      }
      this.props.policy.setHealthData(insured, indexInsured > -1 ? indexInsured : undefined);
      this.props.saveHiring(true);

      let newInsuredList = this.props.data.insureds;

      if (indexInsured === -1) {
        indexInsured = newInsuredList.length - 1;
        this.props.goToInsured(indexInsured);
      } else {
        const coverages =
          newInsuredList[indexInsured] !== undefined ? newInsuredList[indexInsured].coverages : [];
        newInsuredList[indexInsured] = { ...insured, coverages };
      }

      this.setState(
        {
          anyChange: false,
          indexInsured,
        },
        () => this.props.haveInsuredSaved(false),
      );
    }
  }

  removeInsured() {
    const { onGotoDetail, indexRemove } = this.props;

    if (onGotoDetail && onGotoDetail > indexRemove) {
      const index = onGotoDetail - 1;
      this.props.history.replace(`/contratacion/nueva/salud-pymes/asegurados/${index}`);
    }
  }

  onNextClick(forceNext: boolean = false) {
    const insureds = this.props.data.insureds;
    const minInsureds = deepGet(this.props.policy, "product.products_minInsureds", 2) || 2;

    if (insureds.length < minInsureds) {
      this.setState({ showMinInsuredsModal: true });
      return;
    }

    if (forceNext || !this.state.anyChange) {
      this.props.saveHiring(false, false, true);
      this.props.history.push("/contratacion/nueva/salud-pymes/garantias");
    } else this.setState({ nextModalShow: true });
  }

  onPreviousClick(forcePrevious: boolean = false) {
    if (forcePrevious || !this.state.anyChange)
      this.props.history.push("/contratacion/nueva/salud-pymes/tomador");
    else this.setState({ previousModalShow: true });
  }

  onComponentAnyChange = () => {
    const { anyChange } = this.state;
    if (anyChange === false) {
      this.setState({ anyChange: true });
      this.props.haveInsuredSaved(anyChange);
    }
  };

  receiveInsuredAddress(insuredAddress: AddressData) {
    let { addressData } = this.state;
    addressData = insuredAddress;
    this.setState({ addressData });
  }

  receiveInsuredContact(insuredContact: ContactData) {
    let { contactData } = this.state;
    contactData = insuredContact;
    this.setState({ contactData });
  }

  receiveInsuredPerson(insuredPerson: InsuredPersonalData) {
    let { personalData } = this.state;
    personalData = insuredPerson;
    this.setState({ personalData });
  }

  handleUseTakerData(useData: boolean, type: string) {
    if (type === "personal") {
      this.setState(
        {
          usePersonalData: useData,
          useAddressData: useData,
          useContactData: useData,
          isPersonalCheckChanging: true,
          sameAsTakerChecked: useData,
        },
        () => this.setState({ isPersonalCheckChanging: false }),
      );

      if (useData) {
        this.setState({
          hasLegalRepre: false,
          legalGuardian: emptyLegalGuardianData,
        });
      }
    } else {
      if (!this.state.usePersonalData) {
        this.setState({ useAddressData: useData });
      } else {
        this.setState({ useAddressData: useData });
      }
    }
  }

  checkDataIsValid(): boolean {
    const insuredList = this.props.data.insureds;
    if (insuredList && insuredList.length > 0) {
      // filtra la lista de asegurados a los que se les ha completado sus datos (isDataValid)
      const validInsuredList = insuredList.filter((insured: any) => insured.isDataValid);
      return validInsuredList.length === insuredList.length;
    }
    return false;
  }

  getInsuredsAdress = (insureds: any[] | undefined): AddressData[] | undefined => {
    if (!insureds || !insureds.length) {
      return undefined;
    }
    return insureds.map((obj) => obj.address);
  };

  handleInsuredAsTakerChange() {
    let insuredList = this.props.data.insureds;
    let { policy, saveHiring, data } = this.props;

    let haveChanges: boolean = false;
    insuredList.forEach((insured: StateInsuredData, indexInsured: number) => {
      if (insured.sameAsTaker) {
        //Validación por si el tomador cambió a persona jurídica
        if (!data.taker.physicalPerson) {
          insured.sameAsTaker = false;
        } else {
          insured = this.handleGetTakerPersonalData(insured, data.taker);
        }

        policy.setHealthData(insured, indexInsured > -1 ? indexInsured : undefined);
        haveChanges = true;
      }

      if (insured.address.sameAsTaker) {
        insured = this.handleGetTakerAddressData(insured, data.taker);

        policy.setHealthData(insured, indexInsured > -1 ? indexInsured : undefined);
        haveChanges = true;
      }
    });

    haveChanges && saveHiring(true);
  }

  handleGetTakerPersonalData(insured: StateInsuredData, taker: Taker): StateInsuredData {
    if (this.props.data.questionnaires && this._existsQuestionnaire(insured.docNumber)) {
      if (taker.docNumber !== insured.docNumber) {
        // Tenemos que actualizar cuestionarios
        this.props.data.questionnaires[taker.docNumber] =
          this.props.data.questionnaires[insured.docNumber];
        delete this.props.data.questionnaires[insured.docNumber];
        // aqui tenemos guardada la key del questionary pero nos falta actualizar el docNumber
        this.props.data.questionnaires[taker.docNumber].insuredDocNumber = taker.docNumber;
      }
      if (!moment(taker.birthDate).isSame(moment(insured.birthDate))) {
        if (this.props.data.questionnaires[insured.docNumber])
          this.props.data.questionnaires[insured.docNumber].questionnaireData.questionnaireResponse[
            "04"
          ].value = moment(taker.birthDate).format("DD/MM/YYYY");
        else if (this.props.data.questionnaires[taker.docNumber])
          this.props.data.questionnaires[taker.docNumber].questionnaireData.questionnaireResponse[
            "04"
          ].value = moment(taker.birthDate).format("DD/MM/YYYY");
      }
      if (taker.gender !== insured.gender) {
        if (this.props.data.questionnaires[insured.docNumber])
          this.props.data.questionnaires[insured.docNumber].questionnaireData.questionnaireResponse[
            "02"
          ].value = taker.gender;
        else if (this.props.data.questionnaires[taker.docNumber])
          this.props.data.questionnaires[taker.docNumber].questionnaireData.questionnaireResponse[
            "02"
          ].value = taker.gender;
      }
    }
    insured.name = taker.name;
    insured.lastname1 = taker.lastname1 ? taker.lastname1 : "";
    insured.lastname2 = taker.lastname2;
    insured.birthDate = taker.birthDate;
    insured.docType = taker.docType;
    insured.docNumber = taker.docNumber;
    insured.passportDate = taker.passportDate ? taker.passportDate : undefined;
    insured.gender = taker.gender ? taker.gender : "";
    insured.nationality = taker.nationality;
    insured.nationalityLabel = taker.nationalityLabel ? taker.nationalityLabel : "";
    insured.mobilePhone = taker.mobilePhone;
    insured.landlinePhone = taker.landlinePhone;
    insured.emailInput = taker.email;

    return insured;
  }

  handleGetTakerAddressData(insured: StateInsuredData, taker: Taker): StateInsuredData {
    insured.address.address = taker.address.address;
    insured.address.wayType = taker.address.wayType;
    insured.address.number = taker.address.number;
    insured.address.portal = taker.address.portal;
    insured.address.stairs = taker.address.stairs;
    insured.address.floor = taker.address.floor;
    insured.address.door = taker.address.door;
    insured.address.postalCode = taker.address.postalCode;
    insured.address.town = taker.address.town;
    insured.address.province = taker.address.province;
    insured.address.normalizaDireciones = taker.address.normalizaDireciones;

    return insured;
  }

  handleCheckHasLegalRepre = (value: boolean) => {
    this.setState({ hasLegalRepre: value, anyChange: true }, () => this.onComponentAnyChange());
  };

  handleSetLegalRepreData = (value: InsuredLegalRepre) => {
    this.setState({ legalGuardian: value, anyChange: true }, () => this.onComponentAnyChange());
  };

  handleValidateLegalRepreData = (value: boolean) => {
    this.setState(
      {
        validateRepre: { validateRequest: false, isValidated: value },
        anyChange: false,
      },
      () => this.onComponentAnyChange(),
    );
  };

  render() {
    const {
      validateContact,
      validateAddress,
      validatePerson,
      validateRepre,
      cleanForm,
      useAddressData,
      useContactData,
      usePersonalData,
      indexInsured,
      isPersonalCheckChanging,
      cancelSignModalShow,
      showMinInsuredsModal,
      hasLegalRepre,
      sameAsTakerChecked,
      showRepreModal,
    } = this.state;

    const sameAsTaker =
      indexInsured === 0 ? this.props.data.insureds[0].sameAsTaker : sameAsTakerChecked;
    const { isReadOnly } = this.props;

    return (
      <InsuredDataContainer>
        <div className="colSin-100">
          <div className="data-flow-status">
            <div className="data-flow-status-title">
              <h2>DATOS DEL ASEGURADO</h2>
            </div>
          </div>

          <InsuredPersonalInformation
            validate={validatePerson}
            onValidated={(insured: InsuredPersonalData) => this.receiveInsuredPerson(insured)}
            onCheckTakerData={(useData: boolean) => this.handleUseTakerData(useData, "personal")}
            onCleanForm={cleanForm}
            insured={true}
            setLoading={this.props.setLoading}
            taker={this.props.data.taker}
            insureds={this.props.data.insureds}
            insuredIndex={indexInsured}
            isReadOnly={isReadOnly}
            currentHealthStep={SaludPymesHireMenuHelper.getStepFromNavigationRoute(
              this.props.history.location.pathname,
            )}
            onAnyChange={() => {
              this.onComponentAnyChange();
            }}
          />

          {!sameAsTaker && (
            <div className="personal-data-wrapper">
              <div className="flex-row">
                <Label>Representante legal</Label>
                <div className="radioBox">
                  <label>
                    <input
                      type="radio"
                      checked={hasLegalRepre}
                      onChange={() => this.handleCheckHasLegalRepre(true)}
                    />
                    <span className="recover-checkmark">Si</span>
                  </label>
                </div>
                <div className="radioBox">
                  <label>
                    <input
                      type="radio"
                      checked={!hasLegalRepre}
                      onChange={() => this.handleCheckHasLegalRepre(false)}
                    />
                    <span className="recover-checkmark">No</span>
                  </label>
                </div>
              </div>
            </div>
          )}

          <SaludPymesAddressForm
            validate={validateAddress}
            onValidated={(insured: AddressData) => this.receiveInsuredAddress(insured)}
            onCheckTakerData={(useData: boolean) => this.handleUseTakerData(useData, "address")}
            onCleanForm={cleanForm}
            insured={true}
            setLoading={this.props.setLoading}
            useTakerData={useAddressData}
            usePersonalTakerData={usePersonalData}
            taker={this.props.data.taker.address}
            insureds={this.getInsuredsAdress(this.props.data.insureds)}
            insuredIndex={indexInsured}
            isReadOnly={isReadOnly}
            physicalPerson={true}
            isPersonalCheckChanging={isPersonalCheckChanging}
            onAnyChange={() => {
              this.onComponentAnyChange();
            }}
          />

          <SaludPymesContactForm
            validate={validateContact}
            onValidated={(insured: ContactData) => this.receiveInsuredContact(insured)}
            useTakerData={useContactData}
            onCleanForm={cleanForm}
            onEditInsured={indexInsured}
            taker={this.props.data.taker}
            insureds={this.props.data.insureds}
            insuredIndex={indexInsured}
            insured={true}
            isReadOnly={isReadOnly}
            onAnyChange={() => {
              this.onComponentAnyChange();
            }}
            isPersonalCheckChanging={isPersonalCheckChanging}
          />

          {hasLegalRepre && (
            <LegalRepreData
              validate={validateRepre}
              onCleanForm={cleanForm}
              insureds={this.props.data.insureds}
              insuredIndex={indexInsured}
              legalRepreData={this.state.legalGuardian}
              onAnyChange={this.onComponentAnyChange}
              onValidateLegalRepreData={this.handleValidateLegalRepreData}
              setLegalRepreData={this.handleSetLegalRepreData}
              relationshipList={this.state.relationshipList}
              key={indexInsured}
            />
          )}

          <div className="colSin-100 topMargin20 bottomMargin20">
            <div className="personal-data-buttons">
              <div className="personal-data-buttons__item">
                <MainButton
                  withTab={true}
                  icon={true}
                  type={"white"}
                  iconImg={images.IconArrowLeftBlue}
                  text="Atrás"
                  onClick={() => this.onPreviousClick()}
                />
              </div>
              <div className="personal-data-buttons__item">
                <MainButton
                  disabled={!this.checkDataIsValid()}
                  withTab={true}
                  text="Siguiente"
                  onClick={() => this.onNextClick()}
                />
              </div>
            </div>
          </div>

          <LeftInfoModal
            img={images.IconWarningYellow}
            mainTitle={"¿Seguro que desea continuar sin guardar?"}
            mainText={"Perderá todos los cambios introducidos."}
            buttonText="Continuar"
            closeButtonText="Cancelar"
            close={() => this.setState({ previousModalShow: false })}
            active={this.state.previousModalShow}
            onClickAccept={() =>
              this.setState({ previousModalShow: false }, () => this.onPreviousClick(true))
            }
            className="error"
          />

          <LeftInfoModal
            img={images.IconWarningYellow}
            mainTitle={"¿Seguro que desea continuar sin guardar?"}
            mainText={"Perderá todos los cambios introducidos."}
            buttonText="Continuar"
            closeButtonText="Cancelar"
            close={() => this.setState({ nextModalShow: false })}
            active={this.state.nextModalShow}
            onClickAccept={() =>
              this.setState({ nextModalShow: false }, () => this.onNextClick(true))
            }
            className="error"
          />
          <LeftInfoModal
            img={images.IconWarningYellow}
            className="error"
            mainTitle={"¿Seguro que desea continuar?"}
            mainText={"Se cancelará la firma previamente solicitada"}
            buttonText="Continuar"
            closeButtonText="Cancelar"
            close={() => this.setState({ cancelSignModalShow: false })}
            active={cancelSignModalShow}
            onClickAccept={() => {
              this.setState({ cancelSignModalShow: false }, () => this.validateAndSave());
            }}
          />

          <LeftInfoModal
            img={images.IconWarningYellow}
            className="info"
            mainTitle="El número mínimo de asegurados es de 2."
            buttonText="Aceptar"
            close={() => this.setState({ showMinInsuredsModal: false })}
            active={showMinInsuredsModal}
            onClickAccept={() => {
              this.setState({ showMinInsuredsModal: false });
            }}
            noSecondaryButton
          />

          <LeftInfoModal
            img={images.IconWarningYellow}
            className="info"
            mainTitle="El asegurado es menor de edad, debe tener un representante legal."
            buttonText="Aceptar"
            close={() => this.setState({ showRepreModal: false })}
            active={showRepreModal}
            onClickAccept={() => {
              this.setState({ showRepreModal: false });
            }}
            noSecondaryButton
          />
        </div>
      </InsuredDataContainer>
    );
  }
}

export default withCoverages(withPolicy(withGeneral(withRouter(SaludPymesInsured))));
